import type { MultiPolygon } from "geojson";
import { stringToJSONSchema } from "src/utils/zod";
import { z } from "zod";

export const mutliPolygonGeometrySchema = z.object({
  type: z.literal("MultiPolygon"),
  coordinates: z.array(z.array(z.array(z.tuple([z.number(), z.number()])))),
});
export const polygonGeometrySchema = z.object({
  type: z.literal("Polygon"),
  coordinates: z.array(z.array(z.tuple([z.number(), z.number()]))),
});

export const locationPropertiesSchema = z
  .object({
    name: z.string(),
    description: z.string().nullish(),
    color: z.string().nullish(),
    id: z.string(),
  })
  .passthrough();

export type LocationProperties = z.infer<typeof locationPropertiesSchema>;

const locationsGeometrySchema = z.object({
  type: z.literal("FeatureCollection"),
  features: z
    .array(
      z.object({
        type: z.literal("Feature"),
        geometry: mutliPolygonGeometrySchema,
        properties: locationPropertiesSchema,
      }),
    )
    .min(1),
});

export type LocationsGeometry = z.infer<typeof locationsGeometrySchema>;

export const parseLocationGeometry = (
  geometry: unknown,
): MultiPolygon | null => {
  const validationRes = stringToJSONSchema
    .pipe(mutliPolygonGeometrySchema)
    .safeParse(geometry);

  if (!validationRes.success) {
    return null;
  }

  return validationRes.data;
};

export const parseLocationsGeometry = (
  geometry: unknown,
): LocationsGeometry | null => {
  const validationRes = stringToJSONSchema
    .pipe(locationsGeometrySchema)
    .safeParse(geometry);

  if (!validationRes.success) {
    return null;
  }

  return validationRes.data;
};
